<template>
  <div>
    <div>
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'today'"
        :color="currentFilter == 'today' ? 'primary' : 'grey'"
        small
        @click="changeDate('today')"
        >{{ $t("today") }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'yesterday'"
        :color="currentFilter == 'yesterday' ? 'primary' : 'grey'"
        small
        @click="changeDate('yesterday')"
        >{{ $t("yesterday") }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'last_3_days'"
        :color="currentFilter == 'last_3_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_3_days')"
        >{{ $t("last {day} days", { day: 3 }) }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'last_7_days'"
        :color="currentFilter == 'last_7_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_7_days')"
        >{{ $t("last {day} days", { day: 7 }) }}</v-btn
      >

      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'last_15_days'"
        :color="currentFilter == 'last_15_days' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_15_days')"
        >{{ $t("last {day} days", { day: 15 }) }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'this_month'"
        :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_month')"
        >{{ $t("this month") }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'this_year'"
        :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
        small
        @click="changeDate('this_year')"
        >{{ $t("this year") }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'last_month'"
        :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_month')"
        >{{ $t("last 30 days") }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'last_365_day'"
        :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
        small
        @click="changeDate('last_365_day')"
        >{{ $t("last 365 days") }}</v-btn
      >
      <v-btn
        class="ma-0 mr-1 mb-1"
        depressed
        :outlined="currentFilter != 'custom_date'"
        :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
        small
        @click="changeDate('custom_date')"
        >{{ $t("Custom Date") }}</v-btn
      >
    </div>

    <div
      class="grey lighten-5 pa-2 px-4 mt-2"
      style="border-radius:10px;"
      v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'"
    >
      <v-row>
        <v-col cols="12" sm="6">
          <div class="order_summary_datepicker">{{ $t("from") }}:</div>
          <v-row wrap row class="mb-2">
            <v-col :cols="!showTime ? '12' : '8'" class="form-control">
              <v-dialog
                ref="startDateModal"
                v-model="showStartDate"
                :return-value.sync="startdate"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startdate"
                    dense
                    hide-details=""
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startdate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="showStartDate = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.startDateModal.save(startdate)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col v-if="showTime" cols="4" class="form-control">
              <v-dialog
                ref="starttime"
                v-model="showStartTimeDialog"
                :return-value.sync="starttime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <v-text-field
                      type="text"
                      readonly
                      v-on="on"
                      placeholder="00:00"
                      v-model="starttime"
                      outlined
                      dense
                      hide-details=""
                    ></v-text-field>
                  </div>
                </template>
                <v-time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showStartTimeDialog = false">
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.starttime.save(starttime);
                      showStartTimeDialog = false;
                      onSelectedStartDate(enddate);
                    "
                    >{{ $t("Confirm") }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="order_summary_datepicker">{{ $t("to") }}:</div>
          <v-row wrap row class="mb-2">
            <v-col :cols="!showTime ? '12' : '8'" class="form-control">
              <v-dialog
                ref="endDateModal"
                v-model="showEndDate"
                :return-value.sync="enddate"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="enddate"
                    dense
                    hide-details=""
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker v-model="enddate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="showEndDate = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.endDateModal.save(enddate)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col v-if="showTime" cols="4" class="form-control">
              <v-dialog
                ref="endtime"
                v-model="showEndTimeDialog"
                :return-value.sync="endtime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <v-text-field
                      type="text"
                      readonly
                      v-on="on"
                      placeholder="00:00"
                      v-model="endtime"
                      outlined
                      dense
                      hide-details=""
                    ></v-text-field>
                  </div>
                </template>
                <v-time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showEndTimeDialog = false">
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.endtime.save(endtime);
                      showEndTimeDialog = false;
                      onSelectedEndDate(enddate);
                    "
                    >{{ $t("Confirm") }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="text-right mb-2">
        <v-btn color="primary" @click="loadData" :loading="loading">{{ $t("เลือก") }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      default: undefined,
    },
    defaultFilter: {
      default: "last_7_days",
    },
    showTime: {
      default: false,
    },
    loading: {
      default: false,
    },
  },

  data: function() {
    return {
      selectedDate: this.value,
      startdate: null,
      enddate: null,
      currentFilter: this.defaultFilter,
      showStartDate: false,
      showEndDate: false,
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: "00:00",
      endtime: "23:59",
    };
  },
  computed: {},
  mounted() {
    if (this.value) {
      var format = "YYYY-MM-DD";
      if (this.showTime) format = format + " HH:mm";
      console.log(format);
      if (this.value.start) {
        this.startdate = moment(this.value.start).format(format);
      }
      if (this.value.end) {
        this.enddate = moment(this.value.end).format(format);
      }
    }
  },
  methods: {
    clearCurrentFilter() {
      this.currentFilter = "";
    },
    emitDateTime() {
      var vm = this;
      var data = {
        start:
          moment(vm.startdate).format("YYYY-MM-DD") +
          (vm.starttime != null && vm.showTime ? " " + vm.starttime : " 00:00"),
        end:
          moment(vm.enddate).format("YYYY-MM-DD") +
          (vm.endtime != null && vm.showTime ? " " + vm.endtime : " 23:59"),
      };
      vm.$emit("onSelected", data);
      vm.$emit("input", data);
      vm.$emit("changeDate", data);
    },
    changeDate: function(value) {
      var vm = this;
      vm.currentFilter = value;
      switch (value) {
        case "today":
          vm.startdate = moment().format("YYYY-MM-DD 00:00");
          vm.enddate = moment().format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;
        case "yesterday":
          vm.startdate = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;

        case "this_month":
          vm.startdate = moment()
            .startOf("month")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment()
            .endOf("month")
            .format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;
        case "last_3_days":
          vm.startdate = moment()
            .subtract(3, "days")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment().format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;
        case "last_7_days":
          vm.startdate = moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment().format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;
        case "last_15_days":
          vm.startdate = moment()
            .subtract(15, "days")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment().format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;
        case "last_month":
          vm.startdate = moment()
            .subtract(1, "months")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment().format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;

        case "this_year":
          vm.startdate = moment()
            .startOf("year")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment()
            .endOf("year")
            .format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;

        case "last_365_day":
          vm.startdate = moment()
            .subtract(365, "days")
            .format("YYYY-MM-DD 00:00");
          vm.enddate = moment().format("YYYY-MM-DD 23:59");
          vm.starttime = "00:00";
          vm.endtime = "23:59";
          vm.emitDateTime();
          break;

        case "custom_date":
          break;
      }
    },
    onSelectedStartDate: function(value) {
      var vm = this;
      vm.currentFilter = "custom_date";
      if (moment(this.enddate).isBefore(value)) {
        this.enddate = value;
      }
      vm.startdate = value;
      vm.showStartDate = false;
    },
    onSelectedEndDate: function(value) {
      var vm = this;
      vm.currentFilter = "custom_date";
      if (moment(value).isBefore(this.startdate)) {
        this.startdate = value;
      }
      vm.enddate = value;
      vm.showEndDate = false;
    },
    loadData() {
      this.emitDateTime();
    },
  },
  watch: {
    value: function(newVal) {
      this.selectedDate = newVal;

      var format = "YYYY-MM-DD";
      if (this.showTime) format = format + " HH:mm";
      if (newVal) {
        if (newVal.start) {
          this.startdate = moment(newVal.start).format(format);
        }
        if (newVal.end) {
          this.enddate = moment(newVal.end).format(format);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
